/*
 * Plusmedica – Artikelnummer als Line-Item-Property
 * Fügt auf Produktseiten dem Warenkorb-Formular ein verstecktes Feld
 * properties[Art-Nr.] hinzu und hält es mit der aktuell gewählten Variante
 * synchron (SKU = OFA-Artikelnummer). Quelle: /products/<handle>.js (Shopify).
 * Reine JS-Lösung, kein Liquid nötig. Entfernt das Feld, wenn keine SKU vorhanden.
 */
(function () {
  if (!/\/products\//.test(window.location.pathname)) return;

  var PROP = 'properties[Art-Nr.]';
  var skuMap = null;

  function productUrl() {
    var c = document.querySelector('link[rel="canonical"]');
    var base = c ? c.href : window.location.href;
    return base.split('#')[0].split('?')[0];
  }

  function cartForms() {
    return document.querySelectorAll('form[action*="/cart/add"]');
  }

  function sync() {
    if (!skuMap) return;
    cartForms().forEach(function (form) {
      var idEl = form.querySelector('[name="id"]');
      if (!idEl) return;
      var sku = skuMap[String(idEl.value)] || '';
      var field = form.querySelector('input[name="' + PROP + '"]');
      if (!sku) {
        if (field) field.parentNode.removeChild(field);
        return;
      }
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.setAttribute('name', PROP);
        form.appendChild(field);
      }
      field.value = sku;
    });
  }

  // 1) SKU-Map laden
  fetch(productUrl() + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (p) {
      if (!p || !p.variants) return;
      skuMap = {};
      p.variants.forEach(function (v) { skuMap[String(v.id)] = v.sku || ''; });
      sync();
    })
    .catch(function () {});

  // 2) Auf Variantenwechsel reagieren (change-Event)
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') sync();
  });

  // 3) Sicherheitsnetz: id-Wert kann vom Theme ohne change-Event gesetzt werden
  var lastSeen = {};
  setInterval(function () {
    cartForms().forEach(function (form, i) {
      var idEl = form.querySelector('[name="id"]');
      if (idEl && lastSeen[i] !== idEl.value) { lastSeen[i] = idEl.value; sync(); }
    });
  }, 500);

  // 4) Unmittelbar vor dem Absenden nochmals synchronisieren
  document.addEventListener('submit', function () { sync(); }, true);
})();